import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { OrderFulfillmentEditPage } from 'src/app/modals/order-fulfillment-edit/order-fulfillment-edit.page';

const routes: Routes = [
  {
    path: '',
    component: OrderFulfillmentEditPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [OrderFulfillmentEditPage]
})
export class OrderFulfillmentEditPageModule {}
